import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const auth = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

export const courses = {
  getAll: () => api.get('/courses'),
  getOne: (id) => api.get(`/courses/${id}`),
  create: (data) => api.post('/courses', data),
  update: (id, data) => api.put(`/courses/${id}`, data),
  delete: (id) => api.delete(`/courses/${id}`),
};

export const enrollments = {
  create: (data) => api.post('/enrollments', data),
  getMy: () => api.get('/enrollments/my'),
  getAll: () => api.get('/enrollments'),
  verify: (data) => api.post('/enrollments/verify', data),
  cancel: (data) => api.post('/enrollments/cancel', data),
  getReceipt: (enrollmentId) => api.get(`/enrollments/${enrollmentId}/receipt`),
};

export const wallet = {
  getConfig: () => api.get('/wallet/config'),
  updateConfig: (data) => api.put('/wallet/config', data),
  getUpiConfig: () => api.get('/wallet/upi-config'),
  updateUpiConfig: (data) => api.put('/wallet/upi-config', data),
};

export const progress = {
  getMy: () => api.get('/progress/my'),
  update: (courseId, data) => api.put(`/progress/${courseId}`, data),
};

export const reviews = {
  create: (data) => api.post('/reviews', data),
  getCourseReviews: (courseId) => api.get(`/reviews/course/${courseId}`),
  getMyReviews: () => api.get('/reviews/my'),
};

export const admin = {
  getStats: () => api.get('/admin/stats'),
  getActivities: () => api.get('/admin/activities'),
};

export const settings = {
  getAcademySettings: () => api.get('/settings/academy'),
  updateAcademySettings: (data) => api.put('/settings/academy', data),
};

export default api;
